import Vue from "vue";
import VueRouter from "vue-router";
import smartquotes from "smartquotes";
import store from "./store";
// import { component } from "vue/types/umd";
const Home = () => import("../views/Home.vue");

const CategoryView = resolve => {
  require.ensure(["../views/CategoryView.vue"], () => {
    resolve(require("../views/CategoryView.vue"));
  });
};
const Cart = resolve => {
  require.ensure(["../components/Cart.vue"], () => {
    resolve(require("../components/Cart.vue"));
  });
};
const UserLogin = resolve => {
  require.ensure(["../views/UserLogin.vue"], () => {
    resolve(require("../views/UserLogin.vue"));
  });
};
const About = resolve => {
  require.ensure(["../views/About.vue"], () => {
    resolve(require("../views/About.vue"));
  });
};
const FAQ = resolve => {
  require.ensure(["../views/FAQ.vue"], () => {
    resolve(require("../views/FAQ.vue"));
  });
};
const UserProfile = resolve => {
  require.ensure(["../views/UserProfile.vue"], () => {
    resolve(require("../views/UserProfile.vue"));
  });
};
const UserWallet = resolve => {
  require.ensure(["../views/UserWallet.vue"], () => {
    resolve(require("../views/UserWallet.vue"));
  });
};
const UserOrders = resolve => {
  require.ensure(["../views/UserOrders.vue"], () => {
    resolve(require("../views/UserOrders.vue"));
  });
};
const CheckOut = resolve => {
  require.ensure(["../views/CheckOut.vue"], () => {
    resolve(require("../views/CheckOut.vue"));
  });
};
const Search = resolve => {
  require.ensure(["../views/SearchView.vue"], () => {
    resolve(require("../views/SearchView.vue"));
  });
};
const CartView = resolve => {
  require.ensure(["../components/ShoppingCart.vue"], () => {
    resolve(require("../components/ShoppingCart.vue"));
  });
};

//admin

const Dashboard = () => import("../views/admin/Dashboard.vue");

// const Vendor = () => import("../views/admin/Vendor.vue");
const Vendor = resolve => {
  require.ensure(["../views/admin/Vendor.vue"], () => {
    resolve(require("../views/admin/Vendor.vue"));
  });
};
// const VendorRegister = () => import("../views/admin/VendorRegistration.vue");
const VendorRegister = resolve => {
  require.ensure(["../views/admin/VendorRegistration.vue"], () => {
    resolve(require("../views/admin/VendorRegistration.vue"));
  });
};

const Login = () => import("../views/admin/Login.vue");

// const Products = () => import("../views/admin/Products.vue");
const Products = resolve => {
  require.ensure(["../views/admin/Products.vue"], () => {
    resolve(require("../views/admin/Products.vue"));
  });
};
// const Order = () => import("../views/admin/Order.vue");
const Order = resolve => {
  require.ensure(["../views/admin/Order.vue"], () => {
    resolve(require("../views/admin/Order.vue"));
  });
};
// const CustomerList = () => import("../views/admin/CustomerList.vue");
const CustomerList = resolve => {
  require.ensure(["../views/admin/CustomerList.vue"], () => {
    resolve(require("../views/admin/CustomerList.vue"));
  });
};
// const VendorsProducts = () => import("../views/admin/VendorsProducts.vue");
const VendorsProducts = resolve => {
  require.ensure(["../views/admin/VendorsProducts.vue"], () => {
    resolve(require("../views/admin/VendorsProducts.vue"));
  });
};
// const VendorProducts = () => import("../views/admin/VendorProducts.vue");
const VendorProducts = resolve => {
  require.ensure(["../views/admin/VendorProducts.vue"], () => {
    resolve(require("../views/admin/VendorProducts.vue"));
  });
};
// const VendorOrder = () => import("../views/admin/VendorOrder.vue");
const VendorOrder = resolve => {
  require.ensure(["../views/admin/VendorOrder.vue"], () => {
    resolve(require("../views/admin/VendorOrder.vue"));
  });
};
// const VendorProfile = () => import("../views/admin/VendorProfile.vue");
const VendorProfile = resolve => {
  require.ensure(["../views/admin/VendorProfile.vue"], () => {
    resolve(require("../views/admin/VendorProfile.vue"));
  });
};

const ProfilePage = resolve => {
  require.ensure(["../views/admin/ProfilePage.vue"], () => {
    resolve(require("../views/admin/ProfilePage.vue"));
  });
};

// const VendorPacker = () => import("../views/admin/Packer.vue");
const VendorPacker = resolve => {
  require.ensure(["../views/admin/Packer.vue"], () => {
    resolve(require("../views/admin/Packer.vue"));
  });
};
// const Delivery = () => import("../views/admin/Delivery.vue");
const Delivery = resolve => {
  require.ensure(["../views/admin/Delivery.vue"], () => {
    resolve(require("../views/admin/Delivery.vue"));
  });
};
// const VendorUserRole = () => import("../views/admin/VendorUserRole.vue");
const VendorUserRole = resolve => {
  require.ensure(["../views/admin/VendorUserRole.vue"], () => {
    resolve(require("../views/admin/VendorUserRole.vue"));
  });
};
// const AdminUserRole = () => import("../views/admin/AdminUserRole.vue");
const AdminUserRole = resolve => {
  require.ensure(["../views/admin/AdminUserRole.vue"], () => {
    resolve(require("../views/admin/AdminUserRole.vue"));
  });
};
// const ResetPassword = () => import("../views/admin/ResetPassword.vue");
const ResetPassword = resolve => {
  require.ensure(["../views/admin/ResetPassword.vue"], () => {
    resolve(require("../views/admin/ResetPassword.vue"));
  });
};
// const Error = () => import("../views/Error.vue");
const Error = resolve => {
  require.ensure(["../views/Error.vue"], () => {
    resolve(require("../views/Error.vue"));
  });
};
const OrderSuccess = resolve => {
  require.ensure(["../views/OrderSuccess.vue"], () => {
    resolve(require("../views/OrderSuccess.vue"));
  });
};
const OrderFail = resolve => {
  require.ensure(["../views/OrderFail.vue"], () => {
    resolve(require("../views/OrderFail.vue"));
  });
};

const Terms = resolve => {
  require.ensure(["../views/Terms.vue"], () => {
    resolve(require("../views/Terms.vue"));
  });
};
const TermsRefund = resolve => {
  require.ensure(["../views/TermsRefund.vue"], () => {
    resolve(require("../views/TermsRefund.vue"));
  });
};
const Contact = resolve => {
  require.ensure(["../views/Contact.vue"], () => {
    resolve(require("../views/Contact.vue"));
  });
};

const Privacy = resolve => {
  require.ensure(["../views/Privacy.vue"], () => {
    resolve(require("../views/Privacy.vue"));
  });
};
const Packer = resolve => {
  require.ensure(["../views/admin/PackerDashboard.vue"], () => {
    resolve(require("../views/admin/PackerDashboard.vue"));
  });
};
// delivery
const DeliveryDashboard = resolve => {
  require.ensure(["../views/admin/DeliveryDashboard.vue"], () => {
    resolve(require("../views/admin/DeliveryDashboard.vue"));
  });
};
const VendorsProfile = resolve => {
  require.ensure(["../views/VendorProfile.vue"], () => {
    resolve(require("../views/VendorProfile.vue"));
  });
};

const ProductCategory = resolve => {
  require.ensure(["../views/admin/Category.vue"], () => {
    resolve(require("../views/admin/Category.vue"));
  });
};

const Coupon = resolve => {
  require.ensure(["../views/admin/coupon.vue"], () => {
    resolve(require("../views/admin/coupon.vue"));
  });
};
const CouponOrders = resolve => {
  require.ensure(["../views/admin/CouponOrders.vue"], () => {
    resolve(require("../views/admin/CouponOrders.vue"));
  });
};

const routes = [
  {
    path: "/",
    component: Home,
    meta: {
      title: "Home Page"
    }
  },
  {
    path: "/user/profile",
    component: UserProfile,
    meta: {
      title: "Home Page",
      layout: "user",
      auth: true
    }
  },
  {
    path: "/user/wallet",
    component: UserWallet,
    meta: {
      title: "User Wallet",
      layout: "user",
      auth: true
    }
  },
  {
    path: "/vendorProfile/:vendorId",
    component: VendorsProfile,
    meta: {
      title: "Vendor Profile",
      layout: "user"
    }
  },
  {
    path: "/coupons/:id",
    component: CouponOrders,
    meta: {
      title: "Coupon Order",
      layout: "admin"
    }
  },
  {
    path: "/user/orders",
    component: UserOrders,
    meta: {
      title: "Home Page",
      layout: "user",
      auth: true
    }
  },
  {
    path: "/CheckOut",
    component: CheckOut,
    meta: {
      title: "CheckOut Page",
      layout: "user",
      auth: true
    }
  },
  {
    path: "/login",
    component: UserLogin,
    meta: {
      title: "Customer Login",
      layout: "website"
    }
  },
  {
    path: "/about",
    component: About,
    meta: {
      title: "About"
    }
  },
  {
    path: "/FAQ",
    component: FAQ,
    meta: {
      title: "FAQ"
    }
  },
  {
    path: "/cart",
    component: Cart,
    meta: {
      title: "Shopping cart",
      auth: true
    }
  },
  {
    path: "/cartview",
    component: CartView,
    meta: {
      title: "Shopping cart",
      auth: true
    }
  },
  {
    path: "/terms-conditions",
    component: Terms,
    meta: {
      title: "Terms & Conditions"
    }
  },
  {
    path: "/refund-terms",
    component: TermsRefund,
    meta: {
      title: "Refund Returns and Cancellation Policy"
    }
  },
  {
    path: "/privacy-policy",
    component: Privacy,
    meta: {
      title: "Privacy Policy"
    }
  },
  {
    path: "/contact",
    component: Contact,
    meta: {
      title: "Contact Us"
    }
  },

  //admin
  {
    path: "/admin/dashboard",
    component: Dashboard,
    meta: {
      title: "Admin Dashboard",
      layout: "admin",
      adminuserallow: true
    }
  },
  {
    path: "/admin/products",
    component: Products,
    meta: {
      title: "Products List",
      layout: "admin",
      adminuserallow: true
    }
  },
  {
    path: "/vendor/dashboard",
    component: Dashboard,
    meta: {
      title: "Vendor Dashboard",
      layout: "admin",
      vendoruserallow: true
    }
  },
  {
    path: "/admin/vendor",
    component: Vendor,
    meta: {
      title: "Vendor List",
      layout: "admin",
      adminuserallow: true
    }
  },
  {
    path: "/admin/order",
    component: Order,
    meta: {
      title: "Order List",
      layout: "admin",
      adminuserallow: true
    }
  },
  {
    path: "/admin/customerlist",
    component: CustomerList,
    meta: {
      title: "Customer List",
      layout: "admin",
      adminvendorallow: true
    }
  },
  {
    path: "/vendor/products",
    component: VendorsProducts,
    meta: {
      title: "Vendor Products",
      layout: "admin",
      adminuserallow: true
    }
  },
  {
    path: "/vendor/:vendorId/products",
    component: VendorProducts,
    meta: {
      title: "Vendor Products",
      layout: "admin",
      vendoruserallow: true
    }
  },
  {
    path: "/vendor/:vendorId/order",
    component: VendorOrder,
    meta: {
      title: "Vendor Order",
      layout: "admin",
      vendoruserallow: true
    }
  },
  {
    path: "/vendor/packer",
    component: VendorPacker,
    meta: {
      title: "Vendor Packer",
      layout: "admin",
      packeruserallow: true
    }
  },
  {
    path: "/vendorProfile/:vendorId",
    component: ProfilePage,
    meta: {
      title: "Vendor Profile"
    }
  },
  {
    path: "/vendor/:vendorId/profile",
    component: VendorProfile,
    meta: {
      title: "Vendor Profile",
      layout: "admin"
    }
  },
  {
    path: "/vendor/:vendorId/users",
    component: VendorUserRole,
    meta: {
      title: "Vendor Users",
      layout: "admin",
      vendoruserallow: true
    }
  },
  {
    path: "/admin/users",
    component: AdminUserRole,
    meta: {
      title: "Admin Users",
      layout: "admin",
      adminuserallow: true
    }
  },
  {
    path: "/delivery/order",
    component: Delivery,
    meta: {
      title: "Delivery Users",
      layout: "admin",
      deliveryuserallow: true
    }
  },
  {
    path: "/cat/:catId",
    component: CategoryView,
    meta: {
      title: "Category"
    }
  },
  {
    path: "/search/:keyword",
    component: Search,
    meta: {
      title: "Category"
    }
  },
  {
    path: "/vendor/register",
    component: VendorRegister,
    meta: {
      title: "Vendor Registration",
      layout: "website"
    }
  },
  {
    path: "/vendor",
    component: Login,
    meta: {
      title: "Vendor Login",
      layout: "website"
    }
  },
  {
    path: "/delivery",
    component: Login,
    meta: {
      title: "Delivery Login",
      layout: "website"
    }
  },
  {
    path: "/admin",
    component: Login,
    meta: {
      title: "Admin Login",
      layout: "website"
    }
  },
  {
    path: "/resetpassword",
    component: ResetPassword,
    meta: {
      title: "Reset Password",
      layout: "website"
    }
  },
  {
    path: "/error",
    component: Error,
    meta: {
      title: "Error 403",
      layout: "website"
    }
  },
  {
    path: "/orderViaPaytm",
    component: Error,
    meta: {
      title: "Order Via 403",
      layout: "website"
    }
  },
  {
    path: "/orderSuccessful/:ORDERID/:TXNID/:BANKTXNID",
    component: OrderSuccess,
    meta: {
      title: "Success",
      layout: "user"
    }
  },
  {
    path: "/orderFailture/:ORDERID",
    component: OrderFail,
    meta: {
      title: "Fail",
      layout: "user"
    }
  },
  {
    path: "/packer-dashboard",
    component: Packer,
    meta: {
      title: "Packer Dashboard",
      layout: "admin",
      packeruserallow: true
    }
  },
  {
    path: "/delivery-dashboard",
    component: DeliveryDashboard,
    meta: {
      title: "Delivery Dashboard",
      layout: "admin",
      deliveryuserallow: true
    }
  },
  {
    path: "/category-admin",
    component: ProductCategory,
    meta: {
      title: "Category View",
      layout: "admin",
      adminuserallow: true
    }
  },
  {
    path: "/coupons",
    component: Coupon,
    meta: {
      title: "Coupon View",
      layout: "admin",
      adminuserallow: true
    }
  }
];

Vue.use(VueRouter);
const router = new VueRouter({
  routes,
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    const position = savedPosition || {
      x: 0,
      y: 0
    };
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(position);
      }, 200);
    });
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.auth) {
    setTimeout(() => {
      if (!store.state.user) {
        localStorage.setItem("goBackTo", to.path);
        router.push("/");
        return;
      }
    }, 1);
  }
  if (to.meta && to.meta.vendoruserallow) {
    if (store.state.user != null) {
      if (
        store.state.userRole.type !== "vendor" ||
        store.state.userRole.permission !== "admin"
      ) {
        setTimeout(() => {
          router.push("/error");
          return;
        }, 1);
      }
    } else {
      router.push("/");
      return;
    }
  }
  if (to.meta && to.meta.adminuserallow) {
    if (store.state.user != null) {
      if (
        store.state.userRole.type !== "admin" ||
        store.state.userRole.permission !== "admin"
      ) {
        setTimeout(() => {
          router.push("/error");
          return;
        }, 1);
      }
    } else {
      router.push("/");
      return;
    }
  }
  if (to.meta && to.meta.packeruserallow) {
    if (store.state.user != null) {
      if (
        store.state.userRole.type !== "vendor" ||
        store.state.userRole.permission !== "packer"
      ) {
        setTimeout(() => {
          router.push("/error");
          return;
        }, 1);
      }
    } else {
      router.push("/");
      return;
    }
  }
  if (to.meta && to.meta.deliveryuserallow) {
    if (store.state.user != null) {
      if (
        store.state.userRole.type !== "vendor" ||
        store.state.userRole.permission !== "delivery"
      ) {
        setTimeout(() => {
          router.push("/error");
          return;
        }, 1);
      }
    } else {
      router.push("/");
      return;
    }
  }

  if (to.meta && to.meta.adminvendorallow) {
    if (store.state.user != null) {
      if (
        (store.state.userRole.type !== "admin" ||
          store.state.userRole.permission !== "admin") &&
        (store.state.userRole.type !== "vendor" ||
          store.state.userRole.permission !== "admin")
      ) {
        setTimeout(() => {
          router.push("/error");
          return;
        }, 1);
      }
    } else {
      router.push("/");
      return;
    }
  }
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);
  if (nearestWithTitle)
    document.title =
      nearestWithTitle.meta.title +
      ((nearestWithTitle.meta.title.indexOf("DrillMaps") === -1 &&
        " · AamCart") ||
        "");
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);
  from.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);
  Array.from(document.querySelectorAll("[data-routerMetas]")).map(el =>
    el.parentNode.removeChild(el)
  );
  if (!nearestWithMeta) return next();
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement("meta");
      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });
      tag.setAttribute("data-routerMetas", "");
      return tag;
    })
    .forEach(tag => document.head.appendChild(tag));
  next();
});

router.afterEach(() => {
  setTimeout(() => {
    smartquotes();
  }, 301);
});

export default router;
